@if (visible()) {
    <button
        #button
        type="button"
        class="insert-fab"
        data-menu-trigger
        animate.enter="insert-fab-enter"
        animate.leave="insert-fab-leave"
        [class.open]="open()"
        [class.revealed]="revealed()"
        [class.morphed]="morphed()"
        [disabled]="editService.loading()"
        [attr.aria-expanded]="open()"
        (pointerdown)="rememberEditing()"
        (click)="toggle($event)">
        <ra-icon icon="add" varColor="currentColor" [size]="18" />
        <span>{{ 'document.edit.toolbar.insertField' | translate }}</span>
    </button>
}
